import { render, staticRenderFns } from "./SparePartScreen.vue?vue&type=template&id=ff7f12fe"
import script from "./SparePartScreen.vue?vue&type=script&lang=js"
export * from "./SparePartScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports